import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAXRb668joi3pjQyaeGcqjkCi16FYbQBn8",
  authDomain: "fanbayz-5f709.firebaseapp.com",
  projectId: "fanbayz-5f709",
  storageBucket: "fanbayz-5f709.appspot.com",
  messagingSenderId: "337899297557",
  appId: "1:337899297557:web:1316e03b68c3621bc6e71c",
  measurementId: "G-9XVLPCGLKR",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };
